export default "__VITE_ASSET__cytpjcRN__"